import { organizationUserQueryOptions } from '@quoruum/frontend-common/oas/gen/quoruum/@tanstack/react-query.gen';
import { defineEntitySchema } from './base/EntitySchema';

// Memberships are only read as part of an organization, so this schema has no get endpoint.
export const organizationUserSchema = defineEntitySchema({
  name: 'organizationUser',
  label: 'Organization User',
  endpoints: {
    // Each result holds one organization's memberships; every membership is an entity.
    query: organizationUserQueryOptions,
    toItems: (organization) => organization.users,
  },
  primaryText: (member) => member.user.name ?? '',
  secondaryText: (member) => member.role ?? '',
  fields: [
    { key: 'user.name', label: 'User', type: 'string', readOnly: true },
    { key: 'first', label: 'First Name', type: 'string', readOnly: true },
    { key: 'last', label: 'Last Name', type: 'string', readOnly: true },
    {
      key: 'role',
      label: 'Role',
      type: 'enum',
      options: ['OWNER', 'ADMIN', 'MEMBER'],
      readOnly: true,
    },
  ],
});
